// extracted by mini-css-extract-plugin
export default {"errorNotification":"page_errorNotification__Rek6s"};